import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { DenyRxChangeRequestT, ResponseT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { rxChangeAction } from '../api/rxChangeAction.js';
import { rxKeys } from './keys.js';

export interface DenyRxChangeVariables {
  rxChangeId: number;
  data: DenyRxChangeRequestT;
  pendingParams?: {
    detailed?: Parameters<typeof rxKeys.pendingRxChangesDetailed>[0];
  };
}

export function useDenyRxChangeMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['rx', 'rxchanges', 'deny'],
    mutationFn: async ({ rxChangeId, data }: DenyRxChangeVariables): Promise<ResponseT> => {
      return await rxChangeAction.deny(rxChangeId, data);
    },
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: rxKeys.pendingRxChangesDetailed(variables.pendingParams?.detailed),
      });
    },
  });
}
